<script>
import Switches from "vue-switches";

export default {
  props: {
    topbarControls: {
      type: Object,
      required: true
    },
    isGlobal: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      enabled: false,
    }
  },
  watch: {
    topbarControls: {
      handler: function(val) {
        this.enabled = this.isGlobal ? val.selectedItem.practices.find(x => x.practice_id == this.currentPractice.id).active : val.selectedItem.active;
      },
      deep: true
    },
    enabled: {
      handler: function(val) {
        if(this.isGlobal) {
          if(this.topbarControls.selectedItem.practices.find(x => x.practice_id == this.currentPractice.id).active  != val) {
            this.topbarControls.onActiveGlobalFn(val);
          }
        }
        else {
          if(this.topbarControls.selectedItem.active != val) {
            this.topbarControls.onActiveFn(val);
          }
        }
      },
    }
  },
  mounted() {
    this.enabled = this.topbarControls.selectedItem ? 
    this.isGlobal ? this.topbarControls.selectedItem.practices.find(x => x.practice_id == this.currentPractice.id).active 
    : this.topbarControls.selectedItem.active : false;
  },
  components: {
    Switches
  },
};
</script>
<template>
  <div class="d-flex align-items-center justify-content-between pl-3 border-right-dark">
    <span class="font-weight-medium mb-0">Active: </span>
    <img id="info_tooltip" class="align-self-center mx-2"
    src="@/assets/images/info.svg" alt="">
    <b-tooltip target="info_tooltip">Active Status</b-tooltip>
    <switches v-model="enabled" type-bold="false" color="active" class="ml-1 mt-4"></switches>
  </div>
</template>